// Pure helpers for the catalog model's device-profile block. The values mirror
// DEVICE_CAPABILITY_KEYS / DEVICE_CAPABILITY_LEVELS in @platform/shared-types;
// kept local (types only imported) so a stale shared-types dist cannot blank
// the editor — same reason buildTargets.ts guards POS_BUILD_TARGETS.
import type { DeviceCapabilities, DeviceCapabilityKey, DeviceCapabilityLevel } from '@platform/shared-types';

export const CAPABILITY_ROWS: { key: DeviceCapabilityKey; label: string; hint: string }[] = [
  { key: 'printer', label: 'Receipt printer', hint: 'Built-in shows a printer chip that turns red when missing.' },
  { key: 'scanner', label: 'Barcode scanner', hint: 'External shows a chip only when one is plugged in.' },
  { key: 'cardReader', label: 'Card reader', hint: 'Built-in readers skip the pairing step on the till.' },
  { key: 'fingerprint', label: 'Fingerprint', hint: 'None hides fingerprint login on these tills.' },
];

export const LEVEL_LABELS: Record<DeviceCapabilityLevel, string> = { builtin: 'Built-in', external: 'External', none: 'None' };
export const LEVELS: DeviceCapabilityLevel[] = ['builtin', 'external', 'none'];

/** null clears the answer (back to "unanswered"), never writes 'none'. */
export function setCapability(caps: DeviceCapabilities, key: DeviceCapabilityKey, level: DeviceCapabilityLevel | null): DeviceCapabilities {
  const next = { ...caps };
  if (level) next[key] = level; else delete next[key];
  return next;
}
